/**
 * 공통 상수
 */
export const CommonConst = {
  //----------------------------------
  // DB Value
  //----------------------------------
  // rateSystem (ChargeConst에 있던 건데, 공통으로 쓸지?)
  RATE_SYSTEM_BASIC: "베이직",
  RATE_SYSTEM_STANDARD: "스탠다드",
  RATE_SYSTEM_PREMIUM: "프리미엄",
  RATE_SYSTEM_ENTERPRISE: "엔터프라이즈",
  RATE_SYSTEM_OWNER: "소유주",
  // role
  ROLE_CUSTOMER: "고객",
  ROLE_MANAGER: "일반 관리자",
  ROLE_STARTUP_MANAGER: "농창업 관리자",
  ROLE_DESIGN_MANAGER: "전문설계 관리자",
  ROLE_ADMIN: "운영자",
  ROLE_ADMIN_DISTRIBUTION: "관리자(유통/시공사)",
  ROLE_ADMIN_MANUFACTURING: "관리자(제조/도매상)",
  //----------------------------------
  // View Value
  //----------------------------------
  // accessType
  ACCESS_TYPE_MY: "my",
  ACCESS_TYPE_COMPANY: "company",
  ACCESS_TYPE_DEFAULT: "default",
  ACCESS_TYPE_ADMIN: "admin",
  // modifyType (값 자체가 어딘가에서 쓰이는지 확인이 필요)
  MODIFY_TYPE_CREATE: "등록",
  MODIFY_TYPE_INBOUND_CREATE: "인바운드등록",
  MODIFY_TYPE_UPDATE: "수정",
  MODIFY_TYPE_INBOUND_UPDATE: "인바운드수정",
  // 접근형태 (삭제예정)
  accessType: {
    MY: "my",
    COMPANY: "company",
    DEFAULT: "default",
  },
  // 통신 형태 (삭제예정, CONST에 있는 signalType과 겹침ㄷㄷ)
  signalType: {
    CREATE: 0,
    UPDATE: 1,
  },
  dashboard: {
    BROKERAGE: "중개",
    COUNSEL: "상담",
    DESIGN: "설계",
  },
  //----------------------------------
  // notify 메세지
  //----------------------------------
  // 저장
  completeSave: "저장이 완료되었습니다.",
  errorSave: "저장 중 오류가 발생했습니다!",
  // 조회
  errorGet: "조회 중 오류가 발생했습니다!",
  // 삭제
  completeDelete: "삭제가 완료되어습니다.",
  errorDelete: "삭제 중 오류가 발생했습니다!",
  // 수정
  completeUpdate: "수정이 완료되었습니다",
  errorUpdate: "수정 중 오류가 발생했습니다!",
  completeOrder: "순서 변경이 완료되었습니다.",
  errorOrder: "순서 변경 중 오류가 발생했습니다!",
  // 복원
  completeRestore: "복원이 완료되었습니다.",
  errorRestore: "복원 중 오류가 발생했습니다!",
  // 공통
  errorCommon: "오류가 발생했습니다!",
  errorValue: "입력한 값이 유효하지 않습니다.",

  // 파일
  errorExcelDownload: "엑셀 다운로드 중 오류가 발생했습니다!",
  errorMaxFile: "한 번에 10장까지만 업드로 됩니다.",
} as const;
